import { merge } from "lodash-es";
import { darkTheme } from "@rainbow-me/rainbowkit";
import { GlobalStore } from "../store/global/GlobalStore";

export const useBebopTheme = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const themeBackground = theme.theme["300"];
  const bebopTheme = merge(
    darkTheme({
      accentColorForeground: theme.font.primary.default,
      accentColor: theme.button.primary.surface.default,
      overlayBlur: "small",
      borderRadius: "large",
      fontStack: "system",
    }),
    {
      fonts: {
        body: "Work Sans",
      },
      colors: {
        modalBackground: themeBackground,
        modalText: theme.font.primary.default,
        modalTextSecondary: theme.font.secondary.default,
      },
    }
  );
  return bebopTheme;
};
